import {TableIcon} from '@primer/octicons-react'
import {Link, Octicon} from '@primer/react'
import {graphql} from 'react-relay'
import {useFragment} from 'react-relay/hooks'

import {LABELS} from '../constants'

import type {AddedToProjectEvent$key} from './__generated__/AddedToProjectEvent.graphql'
import {TimelineRow} from './row/TimelineRow'

type AddedToProjectEventProps = {
  queryRef: AddedToProjectEvent$key
  issueUrl: string
  highlightedEventId?: string
  refAttribute?: React.MutableRefObject<HTMLDivElement | null>
}

export function AddedToProjectEvent({
  queryRef,
  issueUrl,
  highlightedEventId,
  refAttribute,
}: AddedToProjectEventProps): JSX.Element {
  const {actor, createdAt, project, projectColumnName, databaseId} = useFragment(
    graphql`
      fragment AddedToProjectEvent on AddedToProjectEvent {
        createdAt
        actor {
          ...EventActor
          ...EventActorAvatarItemBadge
        }
        project {
          name
          url
        }
        projectColumnName
        databaseId
      }
    `,
    queryRef,
  )

  if (!project) {
    return <></>
  }
  const highlighted = String(databaseId) === highlightedEventId
  // Once we have support for the project IDs being exposed in GQL we can shift to using the
  // `issueEventExternalUrl` function here for our deep linked timestamp.
  return (
    <TimelineRow
      highlighted={highlighted}
      refAttribute={refAttribute}
      actor={actor}
      createdAt={createdAt}
      actorAvatar={actor}
      deepLinkUrl={issueUrl}
    >
      <>
        {`${LABELS.timeline.addedThisTo} ${projectColumnName} in `}
        <Octicon icon={TableIcon} />{' '}
        <Link href={project.url} sx={{color: 'fg.default', mr: 1}}>
          {project.name}
        </Link>
      </>
    </TimelineRow>
  )
}

try{ AddedToProjectEvent.displayName ||= 'AddedToProjectEvent' } catch {}